import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    top: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    middle: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    campaignColor: {
      type: String,
      required: false,
    },
    discount: {
      type: [Number, String],
      required: true,
    },
    showDiscountText: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
})
export default class DiscountLabelComponent extends Vue {
  degrees() {
    return this.right ? '135deg' : '225deg';
  }

  gradientStyle() {
    return {
      background: `linear-gradient(${this.degrees()}, ${this.campaignColor} 50%, transparent 50%)`,
    };
  }
}
